ci_states
  .state("campaigns", {
    url: "/campaigns?list_start&list_end&run_status_code&q",
    templateUrl: "partials/campaign/campaign_list.html",
    controller: "CampaignListController",
    reloadOnSearch: true,
    ncyBreadcrumb: {
      label: "Campaigns",
    },
  })
  .state("campaign_view", {
    url: "/campaign/:id?start_date&end_date",
    templateUrl: "partials/campaign/campaign_view.html",
    controller: "CampaignViewController",
    reloadOnSearch: true,
    abstract: true,
    ncyBreadcrumb: {
      parent: "campaigns",
      label: "{{ campaign.name }}",
    },
  })
  .state("campaign_view.base", {
    url: "",
    redirectTo: "campaign_view.line_items",
  })
  .state("campaign_view.line_items", {
    url: "/lineitems?run_status_code&ad_publisher_id",
    templateUrl: "partials/line_item/line_item_list.html",
    controller: "CampaignLineItemListController",
    ncyBreadcrumb: {
      label: "Line items",
    },
  })
  .state("campaign_view.analytics", {
    url: "/analytics/:id?publisher&line_item",
    templateUrl: "partials/campaign/campaign_view_analytics.html",
    controller: "CampaignAnalyticsController",
    ncyBreadcrumb: {
      label: "Analytics",
    },
  })
  /* Copying a legacy report into the new reporting system. A child of
     campaign_view because reports.owner_id IS campaigns_v2.id -- the campaign in
     scope already identifies which legacy reports exist and which contract they
     belong to, so there is nothing else to ask for. */
  .state("campaign_view.migrate_reports", {
    url: "/migrate_reports",
    template: '<react scope="scope" feature="feature"></react>',
    controller: [
      "$scope",
      "$stateParams",
      function ($scope, $stateParams) {
        //REACT-FEATURE Campaigns_CampaignView_ReportMigration
        $scope.feature = "Campaigns_CampaignView_ReportMigration";
        $scope.scope = { stateParams: $stateParams };
      },
    ],
    ncyBreadcrumb: {
      label: "Migrate Reports",
    },
  })
  .state("campaign_view.fraud_prevention", {
    url: "/fraud_prevention",
    templateUrl: "partials/campaign/campaign_view_fraud_prevention.html",
    controller: "CampaignFraudPreventionController",
    ncyBreadcrumb: {
      label: "Fraud Prevention",
    },
  })
  .state("campaign_view.pixels", {
    url: "/pixels",
    templateUrl: "partials/campaign/campaign_view_pixels.html",
    controller: "CampaignPixelController",
    ncyBreadcrumb: {
      label: "Pixels",
    },
  })
  .state("campaign_view.applications", {
    url: "/applications",
    templateUrl: "partials/application/application_list.html",
    controller: "ApplicationListController",
    ncyBreadcrumb: {
      label: "Applications",
    },
  })
  .state("campaign_view.ads", {
    url: "/ads",
    templateUrl: "partials/ad/ad_list.html",
    controller: "CampaignAdController",
    ncyBreadcrumb: {
      label: "Creatives",
    },
  })
  .state("campaign_view.ads.ad_view", {
    url: "/:ad_id",
    views: {
      "@": {
        templateUrl: "partials/ad/ad_view.html",
        controller: "AdViewController",
      },
    },
    ncyBreadcrumb: {
      parent: function($scope) {
        $scope.$watch(
          "campaign",
          function() {
            return "campaign_view.ads({id:" + $scope.campaign.id + "})";
          },
          true
        );
      },
      label: "{{ ad.name }}",
    },
  })
  .state("campaign_view.reports", {
    url: "/reports",
    templateUrl: "partials/report/report_list.html",
    controller: "ReportListController",
    ncyBreadcrumb: {
      parent: "campaigns",
      label: "Reports",
    },
  })
  .state("campaign_view.audiences", {
    url: "/audiences",
    templateUrl: "partials/audience/audience_view.html",
    controller: "AudienceViewController",
    ncyBreadcrumb: {
      parent: "campaigns",
      label: "Data Direct Regional",
    },
  })
  .state("campaign_view.publishers", {
    url: "/publishers",
    templateUrl: "partials/campaign/campaign_view_publishers.html",
    ncyBreadcrumb: {
      label: "Publishers",
    },
  })
  .state("lineitems", {
    url: "/campaigns/lineitems/view/:id",
    templateUrl: "partials/line_item/line_item_view.html",
    controller: "LineItemViewController",
    ncyBreadcrumb: {
      parent: "campaigns",
      label: "{{ line_item.name }}",
    },
  })
  .state("lineitems_ad", {
    url: "/campaigns/lineitem/:line_item_id/ad/view/:ad_id",
    templateUrl: "partials/line_item/line_item_ad_view.html",
    controller: "LineItemAdViewController",
    ncyBreadcrumb: {
      parent: "lineitems",
      label: "{{ ad.name }}",
    },
  })
  .state("campaign_demographics", {
    url: "/campaigns/:id/demographics",
    templateUrl: "partials/campaign/analytics/campaign_demographics.html",
    ncyBreadcrumb: {
      parent: "campaigns",
      label: "Demographics",
    },
  });
